// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_pm-8";
export var editMode = "_pm-3";
export var headerRow = "_pm-a";
export var headerTitle = "_pm-b";
export var product = "_pm-1";
export var productDetails = "_pm-5";
export var productDivider = "_pm-7";
export var productImage = "_pm-2";
export var productInfo = "_pm-4";
export var productTitle = "_pm-6";
export var strikethrough = "_pm-9";
export var upsellProductsCard = "_pm-0";